import React from "react";

import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { MedicalDeviceListContent } from "@/pages/patient-medical-file/MedicalDeviceList.tsx";
import { DiabetesTypeInfo, InsulinSchemeInfo, TermDateInfo } from "@/pages/patient-settings/CurrentCarePlan.tsx";
import { Queries } from "@/queries/Queries.ts";
import { Theme } from "@/theme/CreateTheme.ts";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";

export type DiabetesAndDevicesProps = {
  patientId: string;
  className?: string;
};

export const DiabetesAndDevices: React.FC<DiabetesAndDevicesProps> = ({ patientId, className }) => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);
  const condition = Queries.condition.useCondition(patientId);

  return (
    <Card className={className}>
      <CardHeader id="diabetes-and-devices-title" title={t("pages.patientMedicalFile.diabetesAndDevices")} />
      <CardContent className={styles.content}>
        <div className={styles.infoRow}>
          <DiabetesTypeInfo condition={condition} />
          <InsulinSchemeInfo condition={condition} />
          <TermDateInfo condition={condition} />
        </div>
        <div className={styles.devices}>
          <MedicalDeviceListContent patientId={patientId} />
        </div>
      </CardContent>
    </Card>
  );
};

const makeStyles = (theme: Theme) => ({
  content: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(8)};
  `,
  infoRow: css`
    display: flex;
    flex-direction: row;
    gap: max(10%, ${theme.spacing(16)});
    flex-wrap: wrap;
  `,
  devices: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(8)};
  `,
});
